import merge from "lodash/merge"

class Conference {
  constructor() {
    this.id = 0
    this.title = ""
    this.content = ""
    this.address = ""
    this.zbcompany = ""
    this.cbcompany = ""
    this.xbcompany = ""
    this.liveurl = ""
    this.surveyurl = ""
    this.price = 0
    this.status = ""
  }
  static getConferenceList(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/conference"
    if (!filters.per_page || filters.per_page == "") {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let result = {}
      result.conference_list = Array()
      res.data.results.forEach((x) => {
        let c = new Conference()
        Object.assign(c, x)
        result.conference_list.push(c)
      })
      result.total = res.data.total
      // console.log( "getConferenceList");
      // console.log(result);
      return result
    })
  }
  static getCurrentConference() {
    const url = process.env.VUE_APP_API_URL + "api/v1/conference/current"
    return axios.get(url).then((res) => {
      let conference = new Conference()
      conference = Object.assign(conference, res.data.conference)
      return conference
    })
  }

  createOrUpdateConference() {
    const url = process.env.VUE_APP_API_URL + "api/v1/conference"
    if (this.id == 0) {
      //新增
      const data = merge({}, this)

      return axios.post(url, data).then((res) => {
        let result = new Conference()
        result = merge(result, res)
        return result
      })
    } else {
      //修改
      const data = merge({}, this)

      return axios.put(url, data).then((res) => {
        let result = new Conference()
        result = merge(result, res)
        return result
      })
    }
  }
  static delete(id) {
    const url = process.env.VUE_APP_API_URL + "api/v1/conference/"
    return axios.delete(url, { params: { id: id } }).then((res) => {
      return true
    })
  }
}


export default Conference
export { Conference }
